import React from "react";
import { SFRadioGroup } from "@sf-core";
import { Logger } from "@base-provider";

const RADIOS = [
  { label: "Radio 1", value: "radio1" },
  { label: "Radio 2", value: "radio2" },
  { label: "Radio 3", value: "radio3" },
  { label: "Radio 4", value: "radio4", disabled: true },
];

const RadioGroupExample = () => {
  return (
    <SFRadioGroup
      radios={RADIOS}
      name="radio-group-example"
      label="Choose radio"
      onChange={(e) =>
        Logger.of("App.mock.radioGroup.onChange").info({
          checked: e.target.value,
        })
      }
    />
  );
};

export default RadioGroupExample;
